import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { PageViewApiService } from "@core/api/v1";
import { DialogModule } from "primeng/dialog";

@Component({
  selector: 'app-wichtige-informationen',
  standalone: true,
    imports: [
        DialogModule,
    ],
  templateUrl: './wichtige-informationen.component.html',
  styleUrl: './wichtige-informationen.component.scss'
})
export class WichtigeInformationenComponent {
    visible: boolean;
    content: SafeHtml;
    ueberschrift: string | null;

    constructor(private api: PageViewApiService, private sanitizer: DomSanitizer) {

    }

    openOverlay() {
        this.visible = true;
        this.loadContent();
    }

    closeOverlay() {
        this.visible = false;
        this.setCookie("information", "gelesen", 14);
    }

    setCookie(cName: string, cValue: string, expDays: number) {
        let date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
    }

    loadContent() {
        this.api.getPage("pop-up").subscribe(p => {
            this.ueberschrift = p.titel!;
            this.content = this.sanitizer.bypassSecurityTrustHtml('<style> div p {line-height: 1.3;} div#page h2 {line-height: 2;} div#page h3{line-height:1.7;} div#content p {font-size: 13px; color: #666666;}</style>' + p.seite!);
        });
    }
}
